import React, { Component } from "react";
import { Form, Modal } from "reactstrap";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Cargando from '../../../../components/Generales/ModalCargando';
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Snackbar from "components/Snackbar/Snackbar.jsx";
import Globales from "utils/Globales";
import basicsStyle from "assets/jss/material-kit-pro-react/views/componentsSections/basicsStyle.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import { Save, Clear, Search, Check, Block, ArrowForwardIos, Edit, Close, Sync } from "@material-ui/icons";
import ModalPregunta from "components/Generales/ModalPregunta";
import ModalPreguntaEditable from "../../../Generales/ComponentesEmpresas/ModalPreguntaEditable";
import ModalMotivosCancelacion from "../../Asesorias/ModalMotivosCancelacion";


class ConfirmarExamenNotificacion extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      ClassAsesoria: {
        Estado: "Agendada",
        Fecha: new Date(),
        Modalidad: "",
        MotivoCita: "",
        MotivosCancelacion: "",
        NombreAlumno: "",
        NombreAula: "",
        NombreIdioma: "",
        NombreMaestro: "",
        _id: null,
        _idAlumno: null,
        _idAula: null,
        _idIdioma: null,
        _idMaestro: null,
        ExamenAceptado: false,
      },
      idString: "",
      AceptaExamen: "",
      colorNotificacion: "success",
      mensaje: "",
      ImagenAlumno: "",
      Deudas: [],
      MensajeEliminar: "",
      OpEliminar: 0,
      show: false,
      showMotivos: false,
      ExamenTOEFL: false,
      ExamenAceptado: false,
      Motivos: "",
      CuerpoCargando: "Cargando",
    }
  }
  componentDidMount() {
    const hash = window.location.hash;
    const queryString = hash.split('?')[1];
    const params = new URLSearchParams(queryString);

    const acepta = params.get('Acepta');
    const idCita = params.get('id');
    this.state.ClassAsesoria._id = idCita
    this.setState({
      idString: idCita,
      AceptaExamen: acepta == "true",
    }, () => this.init(idCita, acepta))
  }
  init = async (id, acepta) => {
    await this.ObtenerCita(this.state.ClassAsesoria._id)
    if (this.state.AceptaExamen) {
      await this.AceptarRechazarTOEFL(true, "")
    } else {
      this.OpenModalRechazarTOEFL()
    }
  }

  async ObtenerCita(id) {
    this.setState({ cargando: true });
    try {
      const res = await fetch(Globales.Url + 'Citas/Citas/ObtenerInformacionAsesoriaTexto', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token },
        body: JSON.stringify({ _id: this.state.idString })
      });
      const data = await res.json();
      if (data.error) {
        this.setState({ mensaje: data.mensaje, colorNotificacion: 'danger', cargando: false });
        this.showNotification();
      } else {
        debugger
        this.setState({ ClassAsesoria: data.cita, ExamenAceptado: data.cita.ExamenAceptado == "true", cargando: false }, async () => {

        });
      }
    } catch (err) {
      this.setState({ mensaje: "Ocurrió un error inesperado", colorNotificacion: "danger", cargando: false });
    }
  }

  async AceptarRechazarTOEFL(acepta, motivo = "") {
    this.setState({ cargando: true });
    try {
      const res = await fetch(Globales.Url + 'Toefl/Toefl/ConfirmarRechazarExamen', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token },
        body: JSON.stringify({
          idCita: this.state.ClassAsesoria._id,
          idAlumno: this.state.ClassAsesoria._idAlumno,
          Confirmacion: acepta,
          Motivo: motivo,
        })
      });
      const data = await res.json();
      if (data.error) {
        this.setState({ mensaje: data.mensaje, colorNotificacion: 'danger', cargando: false });
        this.showNotification();
      } else {
        let mensaje = acepta ? 'El examen ha sido aceptado exitosamente' : 'El examen ha sido rechazado exitosamente';
        this.setState({ mensaje, colorNotificacion: 'success', cargando: false });
        this.showNotification();
        await this.ObtenerCita(this.state.ClassAsesoria._id);
      }
    } catch (err) {
      this.setState({ mensaje: "Ocurrió un error inesperado", colorNotificacion: "danger", cargando: false });
    }
  }

  showNotification() {
    var x = [];
    this.setState({ br: true });
    this.setState(x);
    this.alertTimeout = setTimeout(
      function () {
        this.setState({ br: false });
        this.setState(x);
      }.bind(this),
      4000
    );
  }

  OpenModalAbonos(Abonos) {
    this.setState({
      showAbonos: true,
      Abonos: Abonos
    })
  }

  EventoModalAbono() {
    this.setState({
      showAbonos: false,
      Abonos: []
    })
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  }
  OpenModalRechazarTOEFL() {
    this.setState({
      show: true,
      TituloCancelacion: "Rechazar examen TOEFL",
      MotivosCancelacion: "¿Está seguro que desea rechazar examen TOEFL?",
    });
  }
  eventoModalEliminar = (Exito) => {
    this.setState({
      show: false,
    });
    if (Exito) {
      this.setState({ showMotivos: true })
    }
  }
  eventoModalmotivos = (mensaje) => {
    this.setState({
      showMotivos: false,
    });
    if (mensaje != 'esc') {
      this.setState({ Motivos: mensaje }, () => {
        this.AceptarRechazarTOEFL(false, mensaje);
      })
    }
  }
  CalcularHorasTranscurridas(FechaInicio, FechaFin) {
    var diferencia = (new Date(FechaFin).getTime() - new Date(FechaInicio).getTime()) / 1000
    diferencia /= (60 * 60)
    diferencia = Math.abs(Math.round(diferencia))

    return Math.abs(Math.round(diferencia))
  }

  CallbackMotivos = (Motivos) => {
    this.setState({
      Motivos: Motivos,
    });
  }

  cerrarModal = () => {
    this.props.eventClick('esc')
  }

  render() {
    const { ExamenTOEFL } = this.state;
    console.log({
      ExamenTOEFL,
      Rechazar: this.state.ClassAsesoria.Estado != "Agendada",
      Cancelar: this.state.ClassAsesoria.Estado != "Agendada",
    });


    let agregar

    if (this.state.show == true) {
      agregar = (
        <ModalPregunta
          Titulo={this.state.TituloCancelacion}
          Cuerpo={this.state.MotivosCancelacion}
          show={this.state.show}
          eventClick={this.eventoModalEliminar}
        />
      );
    }
    if (this.state.showInasistencia == true) {
      agregar = (
        <ModalPregunta
          Titulo={"Marcar inasistencia"}
          Cuerpo={"¿Está seguro que desea marcar inasistencia la cita?"}
          show={this.state.showInasistencia}
          eventClick={this.eventoModalInasistencia}
        />
      );
    }
    if (this.state.showCobrarInasistencia == true) {
      agregar = (
        <ModalPreguntaEditable
          Titulo={"Cobro por inasistencia"}
          Cuerpo={"¿Desea generar cobro por inasistencia?"}
          btnCancelar={"NO"}
          btnAceptar={"SI"}
          show={this.state.showCobrarInasistencia}
          eventClick={this.eventoModalCorarInasistencia}
        />
      );
    }

    if (this.state.showMotivos == true) {
      agregar = (
        <ModalMotivosCancelacion
          Rechazo={this.state.ExamenTOEFL}
          show={this.state.showMotivos}
          eventClick={this.eventoModalmotivos}
          parentCallback={this.CallbackMotivos}
        />
      );
    }
    if (this.state.cargando == true) {
      agregar = (
        <Cargando
          Cuerpo={this.state.CuerpoCargando}
          show={this.state.cargando}
        />
      );
    }

    var TextoEstado = ""
    var colorEstado = ""
    switch (this.state.ClassAsesoria.Estado) {
      case "Agendada":
        if (!this.state.ClassAsesoria.ExamenAceptado) {
          TextoEstado = "Examen agendado"
          colorEstado = "#1a365d"
        } else {

          TextoEstado = "Examen Aceptado"
          colorEstado = "#1a365d"
        }
        break;
      case "Atendida":
        TextoEstado = "Examen presentado"
        colorEstado = "#1a365d"
        break;
      case "Cancelada":
        TextoEstado = "Examen Rechazado"
        colorEstado = "#1a365d"
        break;
    }
    var colorHead = ""
    if (this.state.ClassAsesoria.ColorEstado == "") {
      colorHead = "info"
    } else {
      colorHead = this.state.ClassAsesoria.ColorEstado
    }

    return (
      <div style={{ display: "flex", backgroundColor: "#a0a0a0ff", height: "100dvh", justifyContent: "center", alignItems: "center" }}>
        <div style={{ width: "600px" }}>
          <Card >
            <CardHeader style={{ padding: "15px", backgroundColor: colorEstado, }} >
              <h3 style={{ color: "#f4f4f6" }}>{TextoEstado}</h3>
            </CardHeader>
            <CardBody>
              <table>
                <tbody>
                  <tr>
                    <td><b>Fecha:</b></td>
                    <td>{new Date(this.state.ClassAsesoria.Fecha).toLocaleDateString('en-GB')}</td>
                    <td rowSpan={2}>
                    </td>
                  </tr>
                  <tr>
                    <td><b>Hora:</b></td>
                    <td>{new Date(this.state.ClassAsesoria.Fecha).toLocaleTimeString('en-US')}</td>
                  </tr>
                  <tr>
                    <td><b>Motivo de cita:</b></td>
                    <td>{(this.state.ClassAsesoria.MotivoCita)}</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td rowSpan={2}>
                      <Button style={{ width: "10em" }} tabIndex="2" size='sm' color='danger' className='pull-right' round
                        hidden={this.state.ClassAsesoria.Estado !== "Agendada"}
                        onClick={() => this.OpenModalRechazarTOEFL()}
                      >
                        <Clear />&nbsp; Rechazar
                      </Button>
                    </td>
                  </tr>
                  <tr>
                    <td><b>Aula:</b></td>
                    <td>{this.state.ClassAsesoria.Modalidad == "En_linea" ? "No Aplica" : this.state.ClassAsesoria.NombreAula}</td>
                  </tr>
                  <tr>
                    <td><b>Idioma:</b></td>
                    <td>{this.state.ClassAsesoria.NombreIdioma}</td>
                    <td rowSpan={2}>
                      <Button style={{ width: "10em" }} tabIndex="2" size='sm' color='success' className='pull-right' round
                        hidden={this.state.ClassAsesoria.Estado !== "Agendada"}
                        onClick={() => this.AceptarRechazarTOEFL(true, "")}
                      >
                        <Check />&nbsp; Confirmar
                      </Button>
                    </td>
                  </tr>
                  <tr>
                    <td><b>Maestro:</b></td>
                    <td>{this.state.ClassAsesoria.NombreMaestro}</td>
                  </tr>
                  <tr>
                    <td><b>Alumno:</b></td>
                    <td>{this.state.ClassAsesoria.NombreAlumno}</td>
                  </tr>
                </tbody>
              </table>
              {
                this.state.ClassAsesoria.MotivosCancelacion == null && this.state.ClassAsesoria.Estado == "Cancelada" ?
                  <div className="text-center">
                    <h4 style={{ color: this.state.ClassAsesoria.ColorEstado }}><b>
                      Cancelación de emergencia
                    </b></h4>
                  </div>
                  : null
              }
              {
                this.state.ClassAsesoria.MotivosCancelacion == null ? null :
                  <div className="text-center">
                    <h4 style={{ color: this.state.ClassAsesoria.ColorEstado }}><b>
                      {this.state.ClassAsesoria.MotivosCancelacion}
                    </b></h4>
                  </div>
              }
              <br />
            </CardBody>
          </Card>
          {agregar}
          <div hidden={!this.state.br} id="">
            <Snackbar
              place="tr"
              color={this.state.colorNotificacion}
              message={this.state.mensaje}
              open={this.state.br}
              closeNotification={() => this.setState({ br: false })}
              close
            />
          </div>

        </div>
      </div>
    );
  }
}

export default withStyles(basicsStyle)(ConfirmarExamenNotificacion);